import { local } from 'd3';
// import * as d3 from 'd3';
import { sankeyJustify, sankeyCenter } from 'd3-sankey';
import sankey from './sankey/sankey.js';


// This modules computes the Sankey layout if if needs to be updated.
const sankeyLocal = local();

export const computeSankey = (selection, props) => {
  const node = selection.node();
  const cachedLayout = sankeyLocal.get(node);
    const { data, nodeWidth, nodePadding, innerWidth, innerHeight } = props;
    data.nodes.forEach((n) => {
      delete n.x0;
      delete n.x1;
    });

    let align = (node, n) => {
      if (node.type === "religion") {
        if (node.originalDepth === 1) return n-1;
        if (node.originalHeight === 0) return (n/2);
      } else {
        if (node.originalDepth === 1) return 0;
        if (node.originalHeight === 0) return (n/2) - 1;
      }
      return sankeyJustify(node, n);
    }

    const layout = sankey()
      .city(props.city)
      .nodeWidth(nodeWidth)
      .nodePadding(nodePadding)
      .nodeId(d => d.name)
      .nodeAlign(align)
      .extent([[1, 1], [innerWidth, innerHeight]])
      .iterations(3)(data);

    const spread = innerWidth*0.15;
    const threshold = innerWidth * 0.43;
    layout.nodes.forEach(node => {
      const x = (node.x0 + node.x1) / 2;
      const dx = (x > threshold ? 1 : -1) * spread;
      node.x0 += dx;
      node.x1 += dx;
    });

    sankeyLocal.set(node, layout);
    return layout;
  // }
};



// WEBPACK FOOTER //
// ./src/Sankey/computeSankey.js